import { BrowserRouter } from 'react-router-dom';
import { useProvideErrorHandler } from './hooks';
import { errorHandlerContext } from './contexts';
import Snackbar from './Components/ErrorHandler/Snackbar';
import Routes from './Routes';

function ProvideErrorHandler({ children }) {
  const msg = useProvideErrorHandler();
  return (
    <errorHandlerContext.Provider value={msg}>
      <Snackbar
        alertOpen={msg?.msgConfig.alertOpen}
        handleClose={() => msg?.handleClose()}
        message={msg?.msgConfig.message}
        severity={msg?.msgConfig.severity}
      />
      {children}
    </errorHandlerContext.Provider>
  );
}

function App() {
  return (
    <ProvideErrorHandler>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </ProvideErrorHandler>
  );
}

export default App;
